// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"090d77cd439db003015c","293":"b9f13be49a62d568b6d1","518":"bde09c98e6f2d533b1c8","779":"2e0a2a747cbfb4fcec83"}[chunkId] + ".js";
};